export const futureData = {
  all: {
    text: 'All Events',
    color: '',
  },
  expected: {
    text: 'Active',
    color: 'green',
  },
  potential: {
    text: 'Trialing',
    color: 'lightBlue',
  },
  combined_expected_and_potential: {
    text: 'Trialing + Active',
    color: 'yellow',
  },
  cancellation: {
    text: 'Cancellation',
    color: 'red',
  },
  delinquent: {
    text: 'Delinquent',
    color: 'orange',
  },
};

export const historicalData = {
  all: {
    text: 'All Events',
    color: '',
  },
  SUCCESSFUL_PAYMENT: {
    text: 'Successful Payment',
    color: 'green',
  },
  OVERDUE_PAYMENT: {
    text: 'Overdue Payment',
    color: 'orange',
  },
  CANCELLATION: {
    text: 'Cancellation',
    color: 'red',
  },
};

export function getDefaultMenuOption(data, key) {
  return {
    event: key,
    ...data[key],
  };
}

export function getMenu(data, excludedKeys) {
  let options = [];
  const keys = Object.keys(data);
  const keysLength = keys.length;
  for (let i = 0; i < keysLength; i++) {
    let datapoint = keys[i];
    if (excludedKeys.indexOf(datapoint) < 0) {
      options.push({
        event: datapoint,
        ...data[datapoint],
      });
    }
  }
  return options;
}

export const eventArrayMapping = {
  all: 'eventsAll',
  expected: 'eventsExpected',
  potential: 'eventsPotential',
  cancellation: 'eventsCancellation',
  delinquent: 'eventsDelinquent',
  SUCCESSFUL_PAYMENT: 'eventsExpected',
  OVERDUE_PAYMENT: 'eventsDelinquent',
  CANCELLATION: 'eventsCancellation',
};

export const overallTypes = {
  all: 'MIXED',
  cancellation: 'CANCELLATION',
  delinquent: 'DELINQUENT',
  expected: 'EXPECTED',
  potential: 'POTENTIAL',
  SUCCESSFUL_PAYMENT: 'SUCCESSFUL_PAYMENT',
  OVERDUE_PAYMENT: 'OVERDUE_PAYMENT',
  CANCELLATION: 'CANCELLATION',
};

export default {
  historicalData,
  futureData,
  getDefaultMenuOption,
  getMenu,
  eventArrayMapping,
  overallTypes,
};
